import React from "react";
import { Button, IconButton } from "@mui/material";
import { useDispatch } from "react-redux";
import {
  removeCartItem,
  updateCartItem,
  getCart,
} from "../../../Redux/Customers/Cart/Action";
import AddRoundedIcon from "@mui/icons-material/Add";
import RemoveRoundedIcon from "@mui/icons-material/Remove";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";

const CartItem = ({ item, showButton, showError }) => {
  const dispatch = useDispatch();
  const jwt = localStorage.getItem("jwt");

  const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

  const handleRemoveItemFromCart = async () => {
    await dispatch(removeCartItem({ cartItemId: item?._id, jwt }));
    await dispatch(getCart(jwt));
  };

  const handleUpdateCartItem = async (num) => {
    if (num === 1 && item?.product?.isSizesAvailable) {
      if (
        item?.product?.sizes?.find((prodSize) => prodSize?.name === item?.size)
          ?.quantity === item.quantity
      ) {
        showError("Quantity Not Available!");
        return;
      }
    } else if (!item?.product?.isSizesAvailable) {
      if (num === 1 && item.quantity === item?.product?.quantity) {
        showError("Quantity Not Available!");
        return;
      }
    }
    await dispatch(
      updateCartItem({
        data: { quantity: item.quantity + num },
        cartItemId: item?._id,
        jwt,
      })
    );
    await dispatch(getCart(jwt));
  };

  const img = Array.isArray(item?.product?.images)
    ? item.product.images[0]
    : item?.product?.images;

  return (
    <div className="rounded-2xl border border-[#eadcc0] bg-white p-4 shadow-sm transition-shadow hover:shadow-md">
      <div className="flex gap-4">
        <div className="h-28 w-24 shrink-0 overflow-hidden rounded-xl bg-[#f3ece0] sm:h-32 sm:w-28">
          <img className="h-full w-full object-cover object-top" src={img} alt="" />
        </div>

        <div className="flex min-w-0 flex-1 flex-col">
          <p className="text-[11px] font-semibold uppercase tracking-wide text-[#b28585]">
            {item?.product?.brand}
          </p>
          <p className="truncate font-semibold text-[#511d00]">
            {item?.product?.title}
          </p>

          <div className="mt-1.5 flex flex-wrap gap-2">
            <span className="rounded-md border border-[#eadcc0] px-2 py-0.5 text-xs text-[#5e3e3e]">
              Size: {item?.size ? item?.size : "Free Size"}
            </span>
            <span className="rounded-md border border-[#eadcc0] px-2 py-0.5 text-xs text-[#5e3e3e]">
              Color: {item?.product?.color}
            </span>
          </div>

          <div className="mt-2 flex items-center gap-2">
            <span className="text-lg font-bold text-[#511d00]">
              {inr(item?.product?.discountedPrice)}
            </span>
            {item?.product?.price > item?.product?.discountedPrice && (
              <span className="text-sm text-[#b3a3a3] line-through">
                {inr(item?.product?.price)}
              </span>
            )}
            {item?.product?.discountPercent > 0 && (
              <span className="text-xs font-semibold text-[#2f9e69]">
                {item?.product?.discountPercent}% off
              </span>
            )}
          </div>

          {!showButton && (
            <p className="mt-1 text-sm text-[#5e3e3e]">Qty: {item.quantity}</p>
          )}

          {showButton && (
            <div className="mt-auto flex items-center justify-between pt-3">
              <div className="flex items-center rounded-full border border-[#d8c3c3] bg-white">
                <IconButton aria-label="Decrease quantity"
                  onClick={() => handleUpdateCartItem(-1)}
                  disabled={item?.quantity <= 1}
                  size="small"
                  sx={{ color: "#b28585" }}
                >
                  <RemoveRoundedIcon fontSize="small" />
                </IconButton>
                <span className="min-w-[2rem] text-center text-sm font-semibold text-[#511d00]">
                  {item?.quantity}
                </span>
                <IconButton aria-label="Increase quantity"
                  onClick={() => handleUpdateCartItem(1)}
                  size="small"
                  sx={{ color: "#b28585" }}
                >
                  <AddRoundedIcon fontSize="small" />
                </IconButton>
              </div>

              <Button
                onClick={handleRemoveItemFromCart}
                startIcon={<DeleteOutlineRoundedIcon />}
                sx={{ color: "#b28585", textTransform: "none", fontWeight: 600 }}
              >
                Remove
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CartItem;
